import React, { memo } from "react";
import { Search, X } from "lucide-react";

const SearchInput = memo(function SearchInput({
  value,
  onChange,
  placeholder = "Buscar...",
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      
      {/* 🔥 ICON */}
      <Search
        size={16}
        className="
          absolute left-4 top-1/2 -translate-y-1/2
          text-slate-400 dark:text-slate-500
          pointer-events-none
        "
      />

      {/* 🔥 INPUT */}
      <input
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className="
          w-full
          [&::-webkit-search-cancel-button]:hidden
          rounded-[14px]
          border border-slate-200/80 dark:border-slate-700
          bg-white dark:bg-slate-800
          py-2.5 pl-10 pr-10
          text-[16px] text-slate-900 dark:text-slate-100
          shadow-sm
          outline-none
          transition-all duration-200 ease-out
          placeholder:text-slate-400 dark:placeholder:text-slate-500
          focus:border-brand/50 dark:focus:border-blue-500/60
          focus:ring-4 focus:ring-brand/10 dark:focus:ring-blue-500/10
        "
      />

      {/* 🔥 CLEAR */}
      {value && (
        <button
          type="button"
          onClick={() => onChange?.("")}
          className="
            absolute right-1 top-1/2 -translate-y-1/2
            flex h-11 w-11 items-center justify-center
            active:scale-[0.92]
          "
        >
          {/* Círculo visible (36px, igual que hoy); el botón aporta el tap-area de 44px */}
          <span className="
            flex h-9 w-9 items-center justify-center
            rounded-full
            bg-slate-100 dark:bg-slate-700
            text-slate-500 dark:text-slate-400
            transition-colors
            hover:bg-slate-200 dark:hover:bg-slate-600
          ">
            <X size={13} />
          </span>
        </button>
      )}
    </div>
  );
});

export default SearchInput;